export default __webpack_public_path__ + "static/media/04.813535ed.jpg";